import { createGlobalState } from '@vueuse/core';
import { ref, nextTick } from 'vue';
import { useToasted } from '~/composables/useToasted';
import groupsClient from '~/services/groupsClient';
import { HTTP_INTERNAL_SERVER_ERROR, HTTP_NOT_FOUND } from '~/support/HttpStatuses';

const defaultGroup = () => {
    return {
        group_id: '',
        name: '',
        description: '',
    };
};

export const useGroupDetails = createGlobalState(() => {
    const toasted = useToasted();
    const teamId = Spark.state.currentTeam.id;

    const group = ref(defaultGroup());
    const loading = ref(true);

    const catchRequestError = (error) => {
        console.error(error);
        if (
            !error?.response?.status ||
            error?.response?.status >= HTTP_INTERNAL_SERVER_ERROR ||
            error?.response.status == HTTP_NOT_FOUND
        ) {
            toasted?.global.platform_error();
        } else {
            toasted?.error(error.response?.data?.message || 'Something went wrong.');
        }
    };

    let onMountedGroupCallback = () => {};
    const onMountedGroup = (callback) => {
        onMountedGroupCallback = callback;
    };

    const mount = async (groupId) => {
        await nextTick();

        if (!groupId) {
            group.value = defaultGroup();
            loading.value = false;
            onMountedGroupCallback?.();
            return;
        }

        try {
            loading.value = true;
            const response = await groupsClient.showGroup(teamId, groupId);
            group.value = response.data;
            loading.value = false;
            onMountedGroupCallback?.();
        } catch (e) {
            catchRequestError(e);
        }
    };

    const unmount = () => {
        group.value = defaultGroup();
        loading.value = false;
    };

    return {
        loading,
        group,
        mount,
        unmount,
        onMountedGroup,
    };
});
